declare global {
  interface Window {
    assistantMode?: {
      params?: {
        gameCode?: string
        roomId?: string
        userId?: string
        nickname?: string
        playerId?: string
      }
    }
  }
}

export enum DOMAINS {
  PRACTICE_DEV = 'dev.quintace.dev',
  A5_CLOUD_PRACTICE_STAGE = 'quintace.stg.wptg.a5-labs-cloud.com',
  A5_PRACTICE_STAGE = 'quintace-stg.a5labsapp.co',
  PRACTICE_STG = 'stage.quintace.dev',
  PRACTICE_PROD = 'quintace.co',
  AG_DEVELOPMENT = 'ui-development.quintace.dev',
  AG_STAGING = 'ui-staging.quintace.dev',
  AG_PRODUCTION = 'quintace.ai'
}

export enum ENVIRONMENTS {
  DEVELOPMENT = 'development',
  STAGING = 'staging',
  PRODUCTION = 'production'
}

type EnvConfig = {
  loaderScriptUrl: string
  analysisModeUrl: string
  studyModeUrl?: string
}

const envConfigs: Record<ENVIRONMENTS, EnvConfig> = {
  [ENVIRONMENTS.DEVELOPMENT]: {
    loaderScriptUrl:
      import.meta.env.VITE_ASSISTANT_LOADER_URL_DEV || 'https://asm-dev.quintace.dev',
    analysisModeUrl: import.meta.env.VITE_ANALYSIS_MODE_URL_DEV || 'https://anm-dev.quintace.dev',
    studyModeUrl: import.meta.env.VITE_STUDY_MODE_URL_DEV || 'https://study-dev.quintace.dev'
  },
  [ENVIRONMENTS.STAGING]: {
    loaderScriptUrl: 'https://asm-stage.quintace.dev',
    analysisModeUrl: 'https://anm-stage.quintace.dev',
    studyModeUrl: 'https://study-stage.quintace.dev'
  },
  [ENVIRONMENTS.PRODUCTION]: {
    loaderScriptUrl: 'https://asm-stage.quintace.dev',
    analysisModeUrl: 'https://analysis.quintace.ai',
    studyModeUrl: 'https://study.quintace.dev'
  }
}

export const getEnvironmentFromHostname = () => {
  switch (window.location.hostname) {
    case DOMAINS.AG_PRODUCTION:
    case DOMAINS.PRACTICE_PROD:
      return ENVIRONMENTS.PRODUCTION
    case DOMAINS.PRACTICE_STG:
    case DOMAINS.A5_PRACTICE_STAGE:
    case DOMAINS.A5_CLOUD_PRACTICE_STAGE:
      return ENVIRONMENTS.STAGING
    case DOMAINS.PRACTICE_DEV:
    case DOMAINS.AG_DEVELOPMENT:
    case DOMAINS.AG_STAGING:
    default:
      return ENVIRONMENTS.DEVELOPMENT
  }
}

export const getLoaderScriptUrl = () => {
  const environment = getEnvironmentFromHostname()
  return envConfigs[environment].loaderScriptUrl
}

export const getAnalysisModeUrl = () => {
  const environment = getEnvironmentFromHostname()
  return envConfigs[environment].analysisModeUrl
}

export const getStudyModeUrl = () => {
  const environment = getEnvironmentFromHostname()
  return envConfigs[environment].studyModeUrl
}
